import React from 'react';

const PriceTag = ({ fill }) => {
  return (
    <svg
      width='101'
      height='100'
      viewBox='0 0 101 100'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_21_13)'>
        <path
          d='M83.3052 2.18132C82.9493 1.6142 82.3885 1.2061 81.7395 1.04191C81.0904 0.877721 80.403 0.970093 79.8203 1.29981C79.2376 1.62953 78.8045 2.1712 78.611 2.81214C78.4175 3.45309 78.4786 4.14395 78.7815 4.74102C84.7515 15.3302 78.4709 25.1762 73.3367 30.7692L70.3116 27.7583C69.2949 26.7489 67.3146 26.1144 65.9067 26.351L52.4268 28.8446C50.7878 29.1917 49.2731 29.9753 48.0428 31.1125L13.3204 66.1596C12.5132 66.9772 12.0628 68.0812 12.0678 69.2301C12.0728 70.379 12.5329 71.4791 13.3473 72.2895L36.0762 94.8767C37.7778 96.5577 39.8982 95.9348 41.585 94.2409L76.3066 59.1896C77.3033 58.1752 78.309 56.1935 78.534 54.7765L80.3557 40.7059C80.5814 39.2932 79.9321 37.3173 78.9154 36.308L77.0725 34.4733C83.9569 26.9084 90.2985 14.5914 83.3052 2.18132ZM71.9543 45.1188C71.3144 45.7636 70.5538 46.276 69.7159 46.6267C68.878 46.9774 67.9792 47.1596 67.0708 47.1628C66.1625 47.166 65.2624 46.9903 64.422 46.6455C63.5816 46.3007 62.8174 45.7938 62.173 45.1535C60.8684 43.8582 60.1311 42.0981 60.123 40.2596C60.1148 38.4211 60.8364 36.6546 62.1295 35.3476C63.1435 34.3249 64.4517 33.6446 65.8713 33.4017C67.2909 33.1589 68.7509 33.3657 70.0472 33.9932C69.0214 34.8949 68.3034 35.4439 68.1667 35.5341C67.6873 35.8789 67.3392 36.3763 67.1794 36.9448C67.0197 37.5133 67.0578 38.1192 67.2875 38.6632C67.5171 39.2072 67.9248 39.6571 68.4436 39.9391C68.9625 40.2211 69.5617 40.3186 70.1431 40.2154C70.5071 40.1498 70.8642 39.9979 71.1856 39.7695C71.9363 39.2321 72.7333 38.612 73.553 37.9004C73.9934 39.1321 74.077 40.463 73.7941 41.7401C73.5113 43.0171 72.8735 44.1883 71.9543 45.1188Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_21_13'>
          <rect
            width='86'
            height='86'
            fill='white'
            transform='translate(0.952515 15.272) rotate(-10.2288)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PriceTag;

PriceTag.defaultProps = {
  fill: '#271B71',
};
